import React from "react";

export function CreateForm({ onCreateBlankForm, onCreateExcelForm }) {
  return (
    <div className={`bsy-create-form  `}>
      <div
        class="bsy-excel-form-item bsy-form-blank"
        onClick={onCreateBlankForm}
      >
        <div class="blank-item blank-form"
          style={{
            background: "url(/template/formreport/static/css/resources/images/blank_form.png)",
          }}
        ></div>
        <div class="form-label">
          {React.language("app.edit.formCreate.empty")}
        </div>
      </div>
      <div class="bsy-excel-form-item right" onClick={onCreateExcelForm}>
        <div class="blank-item blank-excel"
          style={{
            background: "url(/template/formreport/static/css/resources/images/blank_excel.png)",
          }}
        ></div>
        <div class="form-label">
          {React.language("app.edit.formCreate.excel")}
        </div>
      </div>
    </div>
  );
}
